import { render, staticRenderFns } from "./UsersOnline.vue?vue&type=template&id=134b53b4&scoped=true"
import script from "./UsersOnline.vue?vue&type=script&lang=js"
export * from "./UsersOnline.vue?vue&type=script&lang=js"
import style0 from "./UsersOnline.vue?vue&type=style&index=0&id=134b53b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b53b4",
  null
  
)

export default component.exports